import QRCode from "qrcode";

export const generateQrCode = (qrCodeSelector: string) => {
  if (!qrCodeSelector) return;

  const elements = document.querySelectorAll(qrCodeSelector);
  if (!elements.length) return;

  const options = {
    type: "image/png",
    quality: 0.8,
    margin: 0,
    width: 200,
    color: {
      dark: "#ffffff",
      light: "#274242",
    },
  };

  elements.forEach(async (el) => {
    const loader = el.querySelector<HTMLElement>(".indicator");
    const qrCodeLink = el.getAttribute("data-qr-link");

    if (!qrCodeLink) {
      console.error("qrCodeLink not found");
      el.innerHTML = `<span class="qr-error">qrCodeLink not found</span>`;
      loader?.remove();
      return;
    }

    const canvas = document.createElement("canvas");

    try {
      await QRCode.toCanvas(canvas, qrCodeLink, options);

      loader?.remove();
      el.appendChild(canvas);
    } catch (error) {
      console.error("QR generation failed:", error);
      el.innerHTML = `<span class="qr-error">QR generation failed</span>`;
    }
  });
};
